import { ButtonHTMLAttributes, ElementType } from "react";
import { twMerge } from 'tailwind-merge'

interface ActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ElementType,
    text?: string
}

export function Action({ icon: Icon, text, ...rest }: ActionProps) {
    return (
        <button
            {...rest}
            className={twMerge("", rest.className)}
        >
            {text}
            {Icon && <Icon />} 
        </button>
    )
}